import { classNames } from '../utils/style';

export const fontQuote = classNames(
  'fontQuote antialiased',
  'font-serif font-semibold',
  'text-20 leading-[25px]',
  'md:text-28 md:leading-33',
  'tracking-[.3px] italic',
  'endFontQuote',
);
export const fontHeadingSerif = classNames(
  'fontHeadingSerif antialiased',
  'font-serif font-bold',
  'text-40 leading-48',
  'md:text-50 md:leading-60',
  'tracking-[.3px]',
  'endFontHeadingSerif',
);
export const fontMegaHeading = classNames(
  'fontMegaHeading antialiased',
  'font-sansDisplay font-semibold',
  'text-38 leading-45',
  'md:text-60 md:leading-72',
  'endFontMegaHeading',
);
export const fontHeading1 = classNames(
  'fontHeading1 antialiased',
  'font-sansDisplay font-semibold',
  'text-38 leading-45',
  'md:text-50 md:leading-60',
  'endFontHeading1',
);
export const fontHeading2 = classNames(
  // ex textTitle1
  'fontHeading2 antialiased',
  'font-sansDisplay font-semibold',
  'text-28 leading-33',
  'md:text-40 md:leading-48',
  'endFontHeading2',
);

export const fontHeading3 = classNames(
  // ex textTitle2
  'fontHeading3 antialiased',
  'font-sansDisplay font-semibold',
  'text-24 leading-28',
  'md:text-32 md:leading-38',
  'endFontHeading3',
);
export const fontHeading4 = classNames(
  // ex textTitle3
  'fontHeading4 antialiased',
  'font-sansDisplay font-semibold',
  'text-24 leading-28',
  'md:text-32 md:leading-38',
  'endFontHeading4',
);
export const fontHeading5 = classNames(
  'fontHeading5 antialiased',
  'font-sansDisplay font-medium',
  'text-20 leading-28',
  'md:text-24 md:leading-29',
  'endFontHeading5',
);
export const fontMegaBody = classNames(
  // ex textBodyLarge
  'fontMegaBody antialiased',
  'font-sans font-normal',
  'text-18 leading-27',
  'md:text-20 md:leading-30',
  'endFontMegaBody',
);
export const fontMegaBodyMedium = classNames(
  'fontMegaBodyMedium antialiased',
  'font-sans font-medium',
  'text-18 leading-27',
  'md:text-20 md:leading-30',
  'endFontMegaBodyMedium',
);
export const fontBody = classNames(
  'fontBody antialiased',
  'font-sans font-normal',
  'text-16 leading-24',
  'md:text-18 md:leading-27',
  'endFontBody',
);
export const fontBodyMedium = classNames(
  'fontBodyMedium antialiased',
  'font-sans font-medium',
  'text-16 leading-24',
  'md:text-18 md:leading-27',
  'endFontBodyMedium',
);
export const fontBodyMini = classNames(
  'fontBodyMini antialiased',
  'font-sans font-normal',
  'text-14 leading-21',
  'md:text-16 md:leading-24',
  'endFontBodyMini',
);
export const fontBodyMiniMedium = classNames(
  'fontBodyMiniMedium antialiased',
  'font-sans font-medium',
  'text-14 leading-21',
  'md:text-16 md:leading-24',
  'endFontBodyMiniMedium',
);
export const fontCaption = classNames(
  // ex textBodySmall
  'fontCaption antialiased',
  'font-sans font-normal',
  'text-14 leading-21',
  'endFontCaption',
);
export const fontCaptionMedium = classNames(
  'fontCaptionMedium antialiased',
  'font-sans font-medium',
  'text-14 leading-21',
  'endFontCaptionMedium',
);
export const fontCaptionTiny = classNames(
  'fontCaptionTiny antialiased',
  'font-sans font-normal',
  'text-12 leading-18',
  'endFontCaptionTiny',
);
export const fontAction = classNames(
  'fontAction antialiased',
  'font-sans font-medium',
  'text-18 leading-27',
  'endFontAction',
);
export const fontActionMini = classNames(
  'fontActionMini antialiased',
  'font-sans font-medium',
  'text-16 leading-24',
  'endFontActionMini',
);

export const fontLabel = classNames(
  'fontLabel antialiased',
  'font-sans font-medium',
  'text-14 leading-22',
  'endFontLabel',
);

export const fontInputLarge = classNames(
  'fontInputLarge antialiased',
  'font-sans',
  'text-[26px] leading-[125%]',
  'md:text-[29px]',
  'endFontInputLarge',
);

export const fontInput = classNames(
  'fontInput antialiased',
  'font-sans font-medium',
  'text-14 leading-24',
  'endFontInput',
);

export const fontTag = classNames(
  'fontTag antialiased',
  'font-sans font-medium',
  'text-14 leading-[21px]',
  'endFontTag',
);

export const decorationUnderlineDotted = classNames(
  'underline underline-offset-[4px]',
  'decoration-dotted decoration-[1.6px]',
  'decoration-[#4E6176]',
);
